<template>
  <button
    v-if="settings"
    :style="`background-color: rgba(${settings.bgColorRGBA});color: rgba(${settings.fontColorRGBA});`"
    type="button"
    class="octadesk-opening-button"
    :class="[
      customClass,
      `octadesk-opening-button--${settings.position}`,
      { 'octadesk-app-active': active },
      { 'notification--offset': hasNotifications }
    ]"
    @click="handleOpen()"
  >
    <span ref="ink" class="octadesk-ripple-ink octadesk-ripple-animate"></span>

    <OctadeskChatIcon class="octadesk-open-button-icon chat--icon--position" />

    <svg
      viewBox="0 0 1024 1024"
      width="16"
      height="16"
      class="octadesk-close-button-icon"
    >
      <use xlink:href="#octadesk-app-icon-close"></use>
    </svg>

    <div
      v-if="hasNotifications && messagesCounter"
      class="octadesk-chat-notification-thumb"
    >
      {{ messagesCounter }}
    </div>
    <div class="svg-stories">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 100 100"
      >
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#f3047c" />

            <stop offset="50%" stop-color="#0171fb" />

            <stop offset="100%" stop-color="#ed0397" />
          </linearGradient>
        </defs>

        <circle
          cx="50"
          cy="50"
          r="47"
          stroke="url(#gradient)"
          stroke-width="6"
          fill="none"
        />
      </svg>
    </div>
  </button>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import OctadeskChatIcon from './OctadeskChatIcon'

  export default {
    components: {
      OctadeskChatIcon
    },
    props: {
      customClass: {
        type: String,
        required: false,
        default: ''
      }
    },
    computed: {
      ...mapGetters([
        'settings',
        'active',
        'unrededMessages',
        'reading',
        'selectedStorie',
        'showStories',
        'canAskSurvey'
      ]),
      messagesCounter() {
        if (this.unrededMessages > 99) {
          return '+99'
        }

        let counter = this.unrededMessages

        if (this.canAskSurvey) {
          counter++
        }

        return counter
      },
      hasNotifications() {
        return !this.active && !this.reading && this.messagesCounter !== 0
      }
    },
    watch: {
      canAskSurvey(value) {
        if (value) {
          this.surveyOpen()
        }
      }
    },
    methods: {
      ...mapActions(['toggleApp', 'enableVueperStories', 'surveyOpen']),
      handleOpen() {
        if (this.showStories && !this.active && !this.selectedStorie) {
          this.enableVueperStories()
        } else {
          this.toggleApp()
        }
      }
    }
  }
</script>

<style lang="scss">
  .octadesk-chat-notification-thumb {
    width: 25px;
    height: 25px;
    background: #ff0000;
    border-radius: 100%;
    position: absolute;
    right: -6px;
    top: -6px;
    color: #ffffff;
    text-align: center;
    font-size: 12px;
    padding-top: 6px;
    font-weight: 600;
  }

  .octadesk-opening-button {
    width: 3.75rem;
    height: 3.75rem;
    position: absolute;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    user-select: none;
    outline: none;
    z-index: 2147483646;
    -webkit-transform: scale(1) rotate(360deg);
    transform: scale(1) rotate(360deg);
    -webkit-transition: box-shadow 0.3s,
      -webkit-transform 150ms cubic-bezier(0.4, 0, 1, 1);
    transition: box-shadow 0.3s, transform 150ms cubic-bezier(0.4, 0, 1, 1);
    backface-visibility: hidden;
    -webkit-font-smoothing: antialiased;
  }
  .octadesk-opening-button--topLeft {
    top: 0;
    left: 0;
  }
  .octadesk-opening-button--topRight {
    top: 0;
    right: 0;
  }
  .octadesk-opening-button--bottomLeft {
    bottom: 0;
    left: 0;
  }
  .octadesk-opening-button--bottomRight {
    right: 0;
    bottom: 0;
  }

  .octadesk-opening-button--topRight.notification--offset {
    top: 6px;
    right: 6px;
  }

  .octadesk-opening-button--topLeft.notification--offset {
    top: 6px;
    left: 0;
  }

  .octadesk-opening-button--bottomRight.notification--offset {
    bottom: 0;
    right: 6px;
  }

  @media screen and (max-device-width: 767px) {
    .octadesk-opening-button--topLeft {
      top: 1.25rem;
      left: 1.25rem;
    }
    .octadesk-opening-button--topRight {
      top: 1.25rem;
      right: 1.25rem;
    }
    .octadesk-opening-button--bottomLeft {
      bottom: 1.25rem;
      left: 1.25rem;
    }
    .octadesk-opening-button--bottomRight {
      right: 1.25rem;
      bottom: 1.25rem;
    }
  }
  .octadesk-open-button-icon,
  .octadesk-close-button-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .octadesk-open-button-icon {
    margin: -1rem;
  }
  .octadesk-close-button-icon {
    margin: -0.5rem;
  }
  .octadesk-close-button-icon,
  .octadesk-app-active .octadesk-open-button-icon {
    opacity: 0;
    -webkit-transform: rotate(225deg);
    transform: rotate(225deg);
  }
  .octadesk-app-active .octadesk-close-button-icon {
    opacity: 1;
    visibility: visible;
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
  .octadesk-ripple-ink {
    display: block;
    position: absolute;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 100%;
    transform: scale(0);
  }

  /* Button animation effects
  --------------------------------------------------*/
  @keyframes octadesk-sharp-curve {
    0%,
    100% {
      -webkit-animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    }
    0% {
      opacity: 0;
      transform: scale3d(0, 0, 0);
      webkit-transform: scale3d(0, 0, 0);
    }
    100% {
      opacity: 1;
      transform: scale3d(1, 1, 1);
      webkit-transform: scale3d(1, 1, 1);
    }
  }
  .octadesk-opening-button {
    animation: octadesk-sharp-curve 0.4s;
  }
  @keyframes octadesk-ripple {
    100% {
      opacity: 0;
      transform: scale(2.5);
    }
  }
  .octadesk-ripple-ink.octadesk-ripple-animate {
    animation: octadesk-ripple 0.65s linear;
  }

  .chat--icon--position {
    top: 55%;
    left: 55%;
  }

  @keyframes stories {
    20%,
    100% {
      transform: scale(1) rotate(0deg);
    }
    0% {
      transform: scale(1) rotate(0deg);
    }
    10% {
      transform: scale(1.05) rotate(360deg);
    }
  }

  .octadesk-opening-button div.svg-stories {
    opacity: 0;
  }
  .octadesk-opening-button.stories {
    border-radius: 50%;
    bottom: 8px;
    right: 8px;
  }

  .octadesk-opening-button.stories div.svg-stories {
    width: calc(100% + 12px);
    height: calc(100% + 12px);
    position: absolute;
    top: -6px;
    left: -6px;
    transition: 0.5s;
    svg {
      width: 100%;
      height: 100%;
    }
  }
  .octadesk-opening-button.stories.closed div.svg-stories {
    animation: stories 8s infinite;
    animation-delay: 1s;
    opacity: 1;
  }
</style>
